import _Vue from "vue"
import WsResponseModel from "src/api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";
import SchoolInfo from "src/api/dataSource/api/EducationSystem/PublicWeb/Api/Models/SchoolModels/SchoolInfo";

abstract class Store<T> implements IStore{

    protected abstract nameVueField:string

    protected abstract GetStore():T

    public install(Vue: typeof _Vue){
        const store = this.GetStore();
        Vue.prototype[this.nameVueField] = store;
        (Vue as any)[this.nameVueField] = store;        
    }
}

export default class MainStore extends Store<MainStore>{

    constructor(){
        super();
        _Vue.$api.SchoolService.GetSchoolInfoEvent.on(this.onGetSchoolInfo.bind(this));         
        //_Vue.$api.SchoolService.GetSchoolInfo();
    }

    protected nameVueField: string = '$mainStore';    
    protected GetStore(): MainStore {
        return this;
    }    

    
    SchoolInfo: SchoolInfo 
    
    //PageTitle:String = "школа-пмр.рф1";
   // ApiUrl:string = ApiUrl;

   private onGetSchoolInfo(res:WsResponseModel<SchoolInfo>){
        if(!res.IsSuccess){
            alert('Произошла ошибка. Пожалуйста, обратитесь в тех.поддержку');
            return;
        }
        this.SchoolInfo = res.Value;
        // this.PageTitle = res.Value.SchoolName;
        // if(res.Value.IsShowSchoolNumber)
        //     this.PageTitle += " №"+res.Value.SchoolNumber;
   }
}




abstract class StoreWithOptions<T,TOptions> implements IStoreWithOptions<TOptions>{

    protected abstract nameVueField:string

    protected abstract GetStore(options:TOptions):T

    install(Vue: typeof _Vue, options?: TOptions){
        const store = this.GetStore(options);
        Vue.prototype[this.nameVueField] = store;
        (Vue as any)[this.nameVueField] = store;
    }
}

interface IStore {
    install(Vue: typeof _Vue): void;
}
interface IStoreWithOptions<T> {
    install(Vue: typeof _Vue, options?: T): void;
}